import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  subAdminuser: [],
  subAdminCount: 0,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const getAllSubAdmin = createAsyncThunk(
  'user/subAdmin',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      //const response = await axios.get('/api/user/subAdmin',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let response = await axios({
        url: `/api/user/subAdmin/?page=${udata}`,
        method: 'get',
        //timeout: 8000,
        headers: {
          //'Content-Type': 'application/json',
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);



export const SearchSubAdmin = (sdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let response = await axios({
      url: `/api/user/subAdmin/${sdata}`,
      method: 'get',
      headers: {
        //'Content-Type': 'application/json',
        "Authorization": `Bearer ${tokenStr}`
      }
    });

    let data = response.data;
    if (response.status === 200) {
      return data;
    }
    else if (data.code === 200) {
      return data;
    }
    else {
      return [];
    }
  } catch (err) {
    if (!err.response) {
      throw err
    }

  }
};




export const subAdminStatusChange = createAsyncThunk(
  'subAdmin/activeStatus',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.patch('/api/user/subAdmin/activeStatus', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      //  console.log(data)
      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);



export const subAdminuserSlice = createSlice({
  name: 'userviewAll',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateSubadmin: (state, { payload }) => {
      //state.user = {};
      // state.isFetching = false;
      // state.isSuccess = false;
      state.isError = false;
      state.errorMessage = '';
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [getAllSubAdmin.fulfilled]: (state, { payload }) => {

      state.subAdminuser = payload.data;
      // state.subAdminuser = payload.data.allUsers;
      state.subAdminCount = payload.data.count;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [getAllSubAdmin.pending]: (state) => {
      state.isFetching = false;
    },
    [getAllSubAdmin.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateSubadmin } = subAdminuserSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateSubadmin());
  }
}

export const subAdminuserSelector = (state) => state.subadmin;

export default subAdminuserSlice.reducer;
